// extracted by mini-css-extract-plugin
export default {"spinner_container":"Spinner_spinner_container__z344W","primary":"Spinner_primary__MxLnj","danger":"Spinner_danger__l73AQ"};